<div class="user-end-validation">
    <div class="message">
        <div class="icon">
            <i-feather name="check"></i-feather>
        </div>
        <h1>{{ 'geral.user-validation.end-validation.title' | translate }}</h1>
        <p>{{ 'geral.user-validation.end-validation.subtitle' | translate }}</p>
    </div>

    <div class="buttons">
        <button id="submitTokenButton" customButton type="submit" [styleType]="'secondary'" [isLoading]="false" label="elemento.generico-botao.ok" (click)="closeModal()"></button>
    </div>
</div>
